// frontend/src/services/researchService.js
// The researcher's Lessons page, lesson detail, label history and training export (YES-272; call map
// section 15). Researchers only (lesson.research, trainingset.export): these are the only screens that
// show model and LLM labels, probabilities and flags. No annotation or adjudication endpoint serves them.
import api from './api';

const enc = encodeURIComponent;

// Every consented upload and every imported lesson; filters, search and paging are in the page
export const listResearchLessons = async () => (await api.get('/api/research/lessons')).data.lessons;

// { lesson, layers: [{ layerId, source, coder, runName }], utterances: [{ seq, speakerRole, text, flag?, labels }] }
export const getResearchLesson = async (lessonId) => (await api.get(`/api/research/lessons/${enc(lessonId)}`)).data;

// Every label ever written for one utterance, newest first
export const getUtteranceHistory = async (lessonId, seq) =>
    (await api.get(`/api/research/lessons/${enc(lessonId)}/utterances/${enc(seq)}/history`)).data.entries;

// rule: best (final › human › model), final, or final_or_human. A .zip with the X-Export-* headers.
export const exportTrainingSet = async ({ lessonIds, rule }) => {
    const response = await api.post('/api/training-export', { lessonIds, rule }, { responseType: 'blob' });
    const h = response.headers || {};
    return {
        blob: response.data,
        fileName: (h['content-disposition'] || '').match(/filename="?([^";]+)"?/)?.[1],
        asOf: h['x-export-as-of'],
        lessons: Number(h['x-export-lessons']) || lessonIds.length,
        utterances: Number(h['x-export-utterances']) || null,
        sha256: h['x-export-sha256'],
    };
};

// Agreement between pairs of coders over the picked runs (YES-269; call map section 14). runs: IDs, no
// default; reference: the human label model–human and LLM–human compare against.
export const getAgreement = async ({ runs, reference }) =>
    (await api.get('/api/agreement', { params: { runs: runs.join(','), reference } })).data;

export const exportAgreementCsv = async ({ runs, reference }) => {
    const response = await api.get('/api/agreement/export', { params: { runs: runs.join(','), reference }, responseType: 'blob' });
    return { blob: response.data, fileName: (response.headers?.['content-disposition'] || '').match(/filename="?([^";]+)"?/)?.[1] };
};
